import {
  HHCheckbox,
  HHFormControlLabel,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { CostShareSetupOptionType } from '../../../../types';
import CostShareSettings from './cost-share-settings';

export interface CostShareSelectProps {
  wholeFormDisabled?: boolean;
  index?: number;
  costShareSetupOptions: CostShareSetupOptionType;
}

export const CostShareSelect = ({
  wholeFormDisabled = false,
  index = 0,
  costShareSetupOptions,
}: CostShareSelectProps): JSX.Element => {
  const watchedCostShareRequired = useWatch({
    name: `selectedPackages.${index}.costShareRequired`,
  });
  const { control, setValue, getValues, resetField } = useFormContext();

  // Set defaults when checked, reset when unchecked
  useEffect(() => {
    if (watchedCostShareRequired) {
      const currentDeductionTiming = getValues(
        `selectedPackages.${index}.deductionTiming`,
      );
      const currentCadence = getValues(`selectedPackages.${index}.cadence`);

      if (
        !currentDeductionTiming &&
        costShareSetupOptions?.deductionTiming?.[0]
      ) {
        setValue(
          `selectedPackages.${index}.deductionTiming`,
          costShareSetupOptions.deductionTiming[0],
        );
      }
      if (!currentCadence && costShareSetupOptions?.cadence?.[0]) {
        setValue(
          `selectedPackages.${index}.cadence`,
          costShareSetupOptions.cadence[0],
        );
      }
    }
  }, [
    watchedCostShareRequired,
    costShareSetupOptions,
    index,
    setValue,
    getValues,
    resetField,
  ]);

  return (
    <HHStack direction="column" spacing={2}>
      <HHTypography hhVariant="caption" color={'GrayText'}>
        Cost Share Settings
      </HHTypography>
      <Controller
        control={control}
        name={`selectedPackages.${index}.costShareRequired`}
        defaultValue={false}
        render={({ field: { onChange, value } }): JSX.Element => (
          <HHFormControlLabel
            control={
              <HHCheckbox
                hhVariant="primary"
                checked={value || false}
                onChange={(e): void => {
                  const isChecked = e.target.checked;
                  onChange(isChecked);
                }}
                disabled={wholeFormDisabled}
                inputProps={{
                  role: 'checkbox',
                  name: 'costShareRequired',
                }}
              />
            }
            label="Cost Share Required"
          />
        )}
      />
      {watchedCostShareRequired && (
        <CostShareSettings
          wholeFormDisabled={wholeFormDisabled}
          index={index}
          costShareSetupOptions={costShareSetupOptions}
        />
      )}
    </HHStack>
  );
};
